import type { FormDataOf, FormDataValue } from '../../../../../types/templates';
import { disneyESPNLogoVsLogo } from '..';
import { findLeague, findTeam, findVariant } from '../data/queries';
import type { LogoVsLogoTeam, TeamsSelection } from '../data/types';

type FormData = FormDataOf<typeof disneyESPNLogoVsLogo>;

const shieldData = (team: LogoVsLogoTeam | undefined, hex: string | undefined, slot: 'local' | 'visitor') => {
  const v = findVariant(team, hex);
  if (!v) return undefined;
  return slot === 'visitor' ? (v.visitorShieldUrl ?? v.shieldUrl) : v.shieldUrl;
};

const syncSide = (
  team: LogoVsLogoTeam | undefined,
  color: string | undefined,
  slot: 'local' | 'visitor',
  updates: Record<string, unknown>
) => {
  const colorKey = slot === 'local' ? 'local-color' : 'visitor-color';
  const shieldKey = slot === 'local' ? 'local-shield-data' : 'visitor-shield-data';
  if (!team || !findVariant(team, color)) {
    updates[colorKey] = '';
    updates[shieldKey] = '';
  } else {
    updates[shieldKey] = shieldData(team, color, slot);
  }
};

export const applyFieldLogic = (fieldKey: string, value: FormDataValue, formData: FormData): Partial<FormData> => {
  const updates: Record<string, unknown> = {};
  const league = formData['league'] as string | undefined;
  const teams = formData['teams'] as TeamsSelection | undefined;
  const localColor = formData['local-color'] as string | undefined;
  const visitorColor = formData['visitor-color'] as string | undefined;

  if (fieldKey === 'league') {
    const l = findLeague(value as string);
    updates['league-logo-data'] = l?.logo ?? '';
    updates['teams'] = { slot1: '', slot2: '' };
    updates['local-color'] = '';
    updates['visitor-color'] = '';
    updates['local-shield-data'] = '';
    updates['visitor-shield-data'] = '';
    updates['matchday'] = '';
  }

  if (fieldKey === 'teams') {
    syncSide(findTeam(league, teams?.slot1), localColor, 'local', updates);
    syncSide(findTeam(league, teams?.slot2), visitorColor, 'visitor', updates);
  }

  if (fieldKey === 'local-color') {
    updates['local-shield-data'] = shieldData(findTeam(league, teams?.slot1), value as string, 'local');
  }

  if (fieldKey === 'visitor-color') {
    updates['visitor-shield-data'] = shieldData(findTeam(league, teams?.slot2), value as string, 'visitor');
  }

  return updates as Partial<FormData>;
};
